import { render, staticRenderFns } from "./bigCourseCard.vue?vue&type=template&id=1bf69ff8&"
import script from "./bigCourseCard.vue?vue&type=script&lang=js&"
export * from "./bigCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./bigCourseCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports